/*
 * @Author: your name
 * @Date: 2021-11-11 13:10:32
 * @LastEditTime: 2022-04-05 22:36:13
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\components\tabbar\index.js
 */
export default{
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        nextTo() {
            setTimeout(() => {
                this.$router.replace('/')
            }, 100);
        }
    },
    computed: {
    },
}